<header class="wizard-header" *transloco="let t" data-testid="wizard-header">
  <div class="header-left">
    <p-button
      data-testid="wizard-header-cancel-btn"
      icon="pi pi-arrow-left"
      [label]="t('common.cancel')"
      severity="secondary"
      [text]="true"
      (onClick)="onCancel()"
    />
  </div>

  <div class="header-right">
    @if (!isViewMode()) {
      <span class="step-indicator" data-testid="wizard-header-step-indicator">{{ t('objects.wizard.header.stepIndicator', { current: currentStep() + 1, total: totalSteps() }) }}</span>
    }
  </div>
</header>
